import React from "react";
import { RightArrowIcon } from "staysure-component-library";

import ButtonWrapper from "@/app/shared-components/button-wrapper/button-wrapper";
import RichText from "@/components/atoms/rich-text/rich-text";

import QuestionDescriptionDrawer from "../../../../../shared-components/question-description/drawer/drawer";
import { useCoverForContext } from "../../../provider/cover-for.provider";

function CoverForDescriptionBody() {
  const {
    groupedCmsData,
    selectedAnswer,
    cmsData,
    isDrawerOpen,
    setIsDrawerOpen,
  } = useCoverForContext();
  const { loadMoreButtonText } = cmsData.overlayArea[0];
  const { body, isLoadMoreButton } =
    groupedCmsData[selectedAnswer].descriptionSection;
  const { drawerData } = groupedCmsData[selectedAnswer].descriptionSection;

  return (
    <>
      <QuestionDescriptionDrawer
        drawerData={drawerData}
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
      />
      <div
        className={`w-full md:p-0 rounded-radius-lg md:border-none ${
          selectedAnswer === "DEFAULT"
            ? ""
            : "border-border-transparent border bg-surface-accent-transparent p-spacing-m  md:bg-transparent "
        }
       `}
      >
        <div
          className={` md:text-xs leading-[24px] md:leading-[27px] ${
            selectedAnswer === "DEFAULT" ? "text-center" : "text-left"
          }
            text-2xs md:mb-spacing-m  text-surface-neutral-option-2`}
        >
          <RichText richText={body} />
        </div>

        {isLoadMoreButton && (
          <div className="load-more-wrapper text-center">
            <ButtonWrapper
              label={loadMoreButtonText}
              hierarchy="tertiary"
              semanticColor="Dark Background"
              id="load-more-button"
              className="text-center font-semibold text-xs !leading-custom-size-xxl"
              isRightIcon
              rightIcon={<RightArrowIcon stroke="white" />}
              onClick={() => setIsDrawerOpen(true)}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default CoverForDescriptionBody;
